import React, { useState, useEffect } from 'react';
import { supabase } from '../../../lib/supabase';
import { useAuth } from '../../../contexts/AuthContext';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const ReviewResponseModal = ({ review, onClose }) => {
  const { user } = useAuth();
  const [loading, setLoading] = useState(false);
  const [responseText, setResponseText] = useState('');

  useEffect(() => {
    if (review?.response_text) {
      setResponseText(review?.response_text);
    }
  }, [review]);

  const handleSubmit = async (e) => {
    e?.preventDefault();
    setLoading(true);

    try {
      const { error: updateError } = await supabase?.from('provider_reviews')?.update({
          response_text: responseText,
          status: 'responded',
          response_date: new Date()?.toISOString(),
          updated_at: new Date()?.toISOString(),
        })?.eq('id', review?.id)?.eq('provider_id', user?.id);

      if (updateError) {
        if (updateError?.code?.substring(0, 2) === '42') {
          console.error('Schema error:', updateError?.message);
          throw updateError;
        } else {
          console.log('Update error:', updateError?.message);
          alert('Fout bij opslaan: ' + updateError?.message);
          return;
        }
      }

      onClose();
    } catch (err) {
      console.error('Error saving response:', err);
      alert('Er is een fout opgetreden');
    } finally {
      setLoading(false);
    }
  };

  const renderStars = (rating) => {
    return (
      <div className="flex items-center space-x-1">
        {[1, 2, 3, 4, 5]?.map((star) => (
          <Icon
            key={star}
            name="Star"
            size={16}
            className={star <= rating ? 'text-warning fill-warning' : 'text-muted'}
          />
        ))}
      </div>
    );
  };

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-card rounded-lg shadow-xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
        <div className="sticky top-0 bg-card border-b border-border p-6 flex items-center justify-between">
          <h2 className="text-xl font-heading font-bold text-foreground">
            Reageren op Review
          </h2>
          <button
            onClick={onClose}
            className="text-muted-foreground hover:text-foreground transition-colors"
          >
            <Icon name="X" size={24} />
          </button>
        </div>

        <div className="p-6 space-y-6">
          {/* Original Review */}
          <div className="bg-muted/50 rounded-lg p-4 border border-border">
            <div className="flex items-center justify-between mb-3">
              <div>
                <h3 className="font-semibold text-foreground">{review?.customer_name}</h3>
                <p className="text-sm text-muted-foreground">{review?.project_type}</p>
              </div>
              {renderStars(review?.rating)}
            </div>
            <p className="text-foreground">{review?.review_text}</p>
          </div>

          {/* Response Form */}
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-foreground mb-2">
                Uw Reactie
              </label>
              <textarea
                required
                value={responseText}
                onChange={(e) => setResponseText(e?.target?.value)}
                rows={6}
                className="w-full rounded-md border border-input bg-background px-3 py-2 text-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
                placeholder="Schrijf een professionele en vriendelijke reactie..."
              />
              <p className="text-xs text-muted-foreground mt-2">
                Tip: Bedank de klant voor hun feedback en ga in op specifieke punten uit hun review.
              </p>
            </div>

            {/* Actions */}
            <div className="flex items-center justify-end space-x-3 pt-4 border-t border-border">
              <Button type="button" variant="outline" onClick={onClose}>
                Annuleren
              </Button>
              <Button type="submit" loading={loading}>
                Reactie Plaatsen
              </Button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ReviewResponseModal;